import { Box, BoxProps } from "@mui/material";
import { IWikifolioDetailDict } from "src/api/server/wf-detail.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { PortfolioTable } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table";

interface IProps extends BoxProps {
    fullName: string;
    dict: IWikifolioDetailDict["portfolioTable"];
}

export const PortfolioTableSection = ({ fullName, dict, ...boxProps }: IProps) => {
    return (
        <Box component="section" {...boxProps}>
            <WfHeading component="h2" fontSize="2xl" sx={{ mb: 3 }}>
                {dict.title}
            </WfHeading>
            <PortfolioTable fullName={fullName} dict={dict} />
        </Box>
    );
};
